import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { authGuard, authChildGuard  } from "./core/guards/auth.guard";
import { mainLayoutRoutes } from "./core/routes/main-layout.routes";
import { ResetPasswordComponent } from "./resources/Auth/reset-password/reset-password.component";
import { MainLayoutComponent } from "./resources/main-layout/main-layout.component";
import { ServerDownComponent } from "./server-down/server-down.component";

const routes: Routes = [
  {
    path: "",
    component: MainLayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authChildGuard],
    children: mainLayoutRoutes
  },
  {
    path: "signin",
    loadChildren: () =>
      import("./resources/Auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "error",
    loadChildren: () =>
      import("./shared/components/error/error.module").then(
        (m) => m.ErrorModule
      ),
  },
  {
    path:"password-reset",
    component:ResetPasswordComponent,
    pathMatch: "full"
  },
  // { path: "**", redirectTo: "error", pathMatch: "full" },
  {
    path: "status-update",
    loadChildren: () =>
      import("./resources/status/status.module").then(
        (m) => m.StatusModule
      ),
  },
  {
    path: "server-down",
    component: ServerDownComponent,
    pathMatch: "full"
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true })
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
